export const prefix = {
  validate: (value) => {
    return /^[\d#]*$/.test(value);
  }
};
